var map = {
	"./1.png": 77019,
	"./2.png": 29037,
	"./3.png": 19069,
	"./4.png": 1655,
	"./5.png": 71492,
	"./adaptive-icon.png": 76323,
	"./back.png": 46988,
	"./bell.png": 31560,
	"./common/Login.png": 32021,
	"./common/Top Icon (1).png": 65087,
	"./common/Top Icon (2).png": 40143,
	"./common/Top Icon (3).png": 63754,
	"./common/Top Icon.png": 13051,
	"./common/home (1).png": 65390,
	"./common/home.png": 4822,
	"./common/menu.png": 71607,
	"./common/search (1).png": 30753,
	"./common/search.png": 58687,
	"./common/user (1).png": 99352,
	"./common/user.png": 88043,
	"./favicon.png": 90216,
	"./freebooks.png": 23503,
	"./home/bookImg1.png": 73715,
	"./home/bookImg2.png": 89309,
	"./home/bookImg3.png": 57263,
	"./home/bookImg4.png": 34904,
	"./home/bookImg5.png": 10772,
	"./home/bookImg6.png": 12801,
	"./home/bookImg7.png": 33230,
	"./home/bookImg8.png": 13721,
	"./home/bookImg9.png": 33234,
	"./icon.png": 31066,
	"./logo.png": 19589,
	"./qr.png": 93195,
	"./splash.png": 7728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39898;